import script from "./TraficPlanTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TraficPlanTable.vue?vue&type=script&setup=true&lang=ts"

import "./TraficPlanTable.vue?vue&type=style&index=0&id=28c95ab6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c95ab6"]])

export default __exports__